import createHttp from '@/config/http';

const http = createHttp(import.meta.env.VITE_INVOICE_URL);

export interface CollectionTrendParams {
	clinicsProductsFilter: string;
	multi_filter: string;
	date_filter_range: string;
}

export interface CollectionTrendResponse {
	data: {
		name: string[];
		value: number[];
	};
	status: number;
	message: string;
}

export interface CollectionAnalysisResponse {
	data: Array<{
		name: string;
		y: number;
	}>;
	status: number;
	message: string;
}

export interface PayorsCollectionsTrendResponse {
	data: Array<{
		primaryInsurance: string;
		PaidDate: string;
		cost: number;
	}>;
	status: number;
	message: string;
}

export const getMonthlyCollectionTrend = async (
	params: CollectionTrendParams,
): Promise<CollectionTrendResponse> => {
	const response = await http.get<CollectionTrendResponse>(
		'/collection/monthlyCollectionTrend',
		{ params },
	);
	return response.data;
};

export const getDailyCollectionTrend = async (
	params: CollectionTrendParams,
): Promise<CollectionTrendResponse> => {
	const response = await http.get<CollectionTrendResponse>(
		'/collection/dailyCollectionTrend',
		{ params },
	);
	return response.data;
};

export const getCollectionsByPayorsAnalysis = async (
	params: CollectionTrendParams,
): Promise<CollectionAnalysisResponse> => {
	const response = await http.get<CollectionAnalysisResponse>(
		'/collection/collectionsByPayorsAnalysis',
		{ params },
	);
	return response.data;
};

export const getCollectionsByProductsAnalysis = async (
	params: CollectionTrendParams,
): Promise<CollectionAnalysisResponse> => {
	const response = await http.get<CollectionAnalysisResponse>(
		'/collection/collectionsByProductsAnalysis',
		{ params },
	);
	return response.data;
};

export const getPayorsCollectionsTrendMonthly = async (
	params: CollectionTrendParams,
): Promise<PayorsCollectionsTrendResponse> => {
	const response = await http.get<PayorsCollectionsTrendResponse>(
		'/collection/payorsCollectionsTrendMonthly',
		{ params },
	);
	return response.data;
};

